"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_dom_1 = require("react-dom");
require("./Animate.css");
var common_anims_1 = require("./anim-lookups/common-anims");
var anim_values_1 = require("./models/anim-values");
var Animate = /** @class */ (function (_super) {
    __extends(Animate, _super);
    ////////////////////////////////////////////
    // Constructor
    ////////////////////////////////////////////
    function Animate(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this.state = {
            currentState: 'INIT',
            hideChild: false,
            targetNodeIsVisible: true,
        };
        _this.bindAll();
        return _this;
    }
    ////////////////////////////////////////////
    // Life-Cycle Methods
    ////////////////////////////////////////////
    Animate.prototype.componentWillMount = function () {
        if (!this.props.options || !this.props.options.isVisible) {
            this.setChildrenVisibility(false);
        }
        this.setState({ targetNodeIsVisible: this.props.options.isVisible });
        this.setAnimationTypes(); // sets the animations that will play on collapse and expand
        this.throwErrOnMultipleWrappedComps();
    };
    Animate.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        this.setElemRefs(); // stores a dom reference to the wrapped element
        this.setAnimPropertiesOnUpdate(); // sets animation related variables when component is updated
        this.setAnimationTypes();
        // Expand
        if (this.props.options
            && this.props.options.isVisible
            && this.props.options.playAnimOnExpand
            && this.state.currentState !== 'EXPANDED'
            && this.props.options.isVisible !== prevProps.options.isVisible) {
            this.setState({ currentState: 'EXPANDED' });
            this.hideChild(true);
            this.setChildrenVisibility(true);
            setTimeout(function () {
                _this.hideChild(false);
                _this.setElemRefs();
                _this.onExpand(_this.animTargetElement);
            });
        }
        // Collapse
        if (this.props.options
            && (!this.props.options.isVisible)
            && this.props.options.playAnimOnCollapse
            && this.state.currentState !== 'COLLAPSED'
            && this.props.options.isVisible !== prevProps.options.isVisible) {
            this.setState({ currentState: 'COLLAPSED' });
            this.setElemRefs();
            if (this.animTargetElement) {
                this.onCollapse(this.animTargetElement);
            }
        }
    };
    ////////////////////////////////////////////
    // General Methods
    ////////////////////////////////////////////
    Animate.prototype.bindAll = function () {
        this.setChildrenVisibility = this.setChildrenVisibility.bind(this);
        this.setAnimationTypes = this.setAnimationTypes.bind(this);
        this.getCollapseAnimType = this.getCollapseAnimType.bind(this);
        this.getExpandAnimType = this.getExpandAnimType.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.onCollapse = this.onCollapse.bind(this);
        this.getExpandType = this.getExpandType.bind(this);
        this.getCollapseType = this.getCollapseType.bind(this);
    };
    Animate.prototype.throwErrOnMultipleWrappedComps = function () {
        if (Array.isArray(this.props.children)) {
            throw new Error("You can only Animate one component at a time. Please check if you are wrapping\n      multiple components");
        }
    };
    ////////////////////////////////////////////
    // SET Methods
    ////////////////////////////////////////////
    Animate.prototype.setChildrenVisibility = function (state) {
        this.setState({ targetNodeIsVisible: state });
    };
    Animate.prototype.setAnimationTypes = function () {
        this.expandAnimType = this.getExpandAnimType();
        this.collapseAnimType = this.getCollapseAnimType();
    };
    Animate.prototype.setAnimPropertiesOnUpdate = function () {
        if (this.containerRef &&
            this.containerRef.current &&
            this.containerRef.current.clientWidth &&
            this.containerRef.current.clientHeight) {
            this.containerWidth = this.containerRef.current.clientWidth;
            this.containerHeight = this.containerRef.current.clientHeight;
        }
    };
    Animate.prototype.setElemRefs = function () {
        // target elem anims will be performed on
        this.animTargetElement = react_dom_1.findDOMNode(this.containerRef.current);
        // create an instance of the animation library
        this.anims = new common_anims_1.default(this.animTargetElement, true);
    };
    Animate.prototype.hideChild = function (state) {
        this.setState({ hideChild: state });
    };
    ////////////////////////////////////////////
    // GET Methods
    ////////////////////////////////////////////
    Animate.prototype.getCollapseAnimType = function () {
        return (this.props.options && this.props.options.collapseAnimType) ?
            this.props.options.collapseAnimType : null;
    };
    Animate.prototype.getExpandAnimType = function () {
        return (this.props.options && this.props.options.expandAnimType) ?
            this.props.options.expandAnimType : null;
    };
    Animate.prototype.getExpandType = function (animType, childNodes, affectChildNodes) {
        var animSettings = this.props.options.expandAnimSettings;
        switch (animType) {
            // EXPAND
            case anim_values_1.ExpandAnimTypes.EXPAND:
                return this.anims.expand({ childOnElem: childNodes, animSettings: animSettings, affectChildNodes: affectChildNodes });
            // PANEL EXPAND
            case anim_values_1.ExpandAnimTypes.EXPAND_PANEL:
                return this.anims.expand({ childOnElem: childNodes, animSettings: animSettings, affectChildNodes: affectChildNodes }, true);
            // SLIDE-FROM-LEFT
            case anim_values_1.ExpandAnimTypes.SLIDE_FROM_LEFT:
                return this.anims.slideFromLeft({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        xPos: this.containerWidth,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-FROM-RIGHT
            case anim_values_1.ExpandAnimTypes.SLIDE_FROM_RIGHT:
                return this.anims.slideFromRight({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        xPos: this.containerWidth,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-FROM-TOP
            case anim_values_1.ExpandAnimTypes.SLIDE_FROM_TOP:
                return this.anims.slideFromTop({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        yPos: this.containerHeight,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-FROM-BOTTOM
            case anim_values_1.ExpandAnimTypes.SLIDE_FROM_BOTTOM:
                return this.anims.slideFromBottom({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        yPos: this.containerHeight,
                    },
                    childOnElem: childNodes,
                });
            // FADE-IN
            case anim_values_1.ExpandAnimTypes.FADE_IN:
                return this.anims.fadeIn();
            // DEFAULT
            default:
                return this.anims.expand({ childOnElem: childNodes });
        }
    };
    Animate.prototype.getCollapseType = function (animType, childNodes, affectChildNodes) {
        var animSettings = this.props.options.collapseAnimSettings;
        var containerWidth = this.containerRef.current.clientWidth;
        var containerHeight = this.containerRef.current.clientHeight;
        switch (animType) {
            // COLLAPSE
            case anim_values_1.CollapseAnimTypes.COLLAPSE:
                return this.anims.collapse({ childOnElem: childNodes, animSettings: animSettings, affectChildNodes: affectChildNodes });
            case anim_values_1.CollapseAnimTypes.COLLAPSE_PANEL:
                return this.anims.collapsePanel({ childOnElem: childNodes, animSettings: animSettings, affectChildNodes: affectChildNodes });
            // PANEL COLLAPSE
            case anim_values_1.CollapseAnimTypes.COLLAPSE_PANEL:
                return this.anims.collapse({ childOnElem: childNodes, animSettings: animSettings, affectChildNodes: affectChildNodes }, true);
            // SLIDE-TO-LEFT
            case anim_values_1.CollapseAnimTypes.SLIDE_TO_LEFT:
                return this.anims.slideToLeft({
                    animSettings: {
                        duration: 500 || anim_values_1.AnimSpeed.MEDIUM,
                        xPos: containerWidth,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-TO-RIGHT
            case anim_values_1.CollapseAnimTypes.SLIDE_TO_RIGHT:
                return this.anims.slideToRight({
                    animSettings: {
                        duration: 500 || anim_values_1.AnimSpeed.MEDIUM,
                        xPos: containerWidth,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-TO-TOP
            case anim_values_1.CollapseAnimTypes.SLIDE_TO_TOP:
                return this.anims.slideToTop({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        yPos: this.containerHeight,
                    },
                    childOnElem: childNodes,
                });
            // SLIDE-TO-BOTTOM
            case anim_values_1.CollapseAnimTypes.SLIDE_TO_BOTTOM:
                return this.anims.slideToBottom({
                    animSettings: {
                        duration: anim_values_1.AnimSpeed.MEDIUM,
                        yPos: this.containerHeight,
                    },
                    childOnElem: childNodes,
                });
            // FADE-OUT
            case anim_values_1.CollapseAnimTypes.FADE_OUT:
                return this.anims.fadeOut();
            // DEFAULT
            default:
                return this.anims.collapse({ childOnElem: childNodes });
        }
    };
    ////////////////////////////////////////////
    // ON Methods
    ////////////////////////////////////////////
    Animate.prototype.onExpand = function (elem) {
        var _this = this;
        var childNodes = [];
        var keys = Object.keys(elem.childNodes);
        keys.forEach(function (key) {
            if (elem && elem.childNodes[key].nodeType === 1) {
                childNodes.push(elem.childNodes[key]);
            }
        });
        this.getExpandType(this.expandAnimType || anim_values_1.ExpandAnimTypes.EXPAND, childNodes, (this.props.options && this.props.options.affectChildNodes === false ? false : true))
            .then(function () {
            if (_this.props.events && _this.props.events.onExpandComplete) {
                _this.props.events.onExpandComplete();
            }
        });
    };
    Animate.prototype.onCollapse = function (elem) {
        var _this = this;
        var childNodes = [];
        var keys = Object.keys(elem.childNodes);
        keys.forEach(function (key) {
            if (elem.childNodes[key].nodeType === 1) {
                childNodes.push(elem.childNodes[key]);
            }
        });
        this.getCollapseType(this.collapseAnimType || anim_values_1.CollapseAnimTypes.COLLAPSE, childNodes, (this.props.options && this.props.options.affectChildNodes === false ? false : true))
            .then(function () {
            _this.setChildrenVisibility(false);
            if (_this.props.events && _this.props.events.onCollapseComplete) {
                _this.props.events.onCollapseComplete();
            }
        });
    };
    ////////////////////////////////////////////
    // RENDER
    ////////////////////////////////////////////
    Animate.prototype.render = function () {
        // destroy target node after collapse animation
        if (!this.props.options.maintainStructure) {
            return (React.createElement("div", { style: { visibility: this.state.hideChild ? 'hidden' : 'visible' } }, (this.state.targetNodeIsVisible) ?
                React.cloneElement(this.props.children, {
                    ref: this.containerRef,
                }) : null));
            // keep parent container from collapsing and target node from being destroyed
        }
        else {
            return (React.createElement("div", { style: { visibility: this.state.hideChild ? 'hidden' : 'visible' } }, React.cloneElement(this.props.children, {
                ref: this.containerRef,
            })));
        }
    };
    return Animate;
}(react_1.Component));
exports.default = Animate;
//# sourceMappingURL=Animate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/Animate.js
// module id = 508
// module chunks = 8